import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-non-employee',
  templateUrl: './non-employee.component.html',
  styleUrls: ['./non-employee.component.scss'],
  standalone: true,
  imports: [],
})
export class NonEmployeeComponent implements OnInit {
  isExistingEmployee: boolean = false;
  userProfileErrorMsg: string | null = null;

  ngOnInit() {
    let isExistingEmployee = sessionStorage.getItem('isExistingEmployee');
    this.isExistingEmployee = isExistingEmployee ? JSON.parse(isExistingEmployee) : false;
    this.userProfileErrorMsg = sessionStorage.getItem('userProfileErrorMsg');
  }
}
